// extracted by mini-css-extract-plugin
module.exports = {"pagetitlebox":"styles_pagetitlebox__2Zoti","marginleft1":"styles_marginleft1__1TrNy","marginright03":"styles_marginright03__3wTjj","pagetitlebox1":"styles_pagetitlebox1__xIcS6"};